import { useState } from "react";
import { useTranslation } from "../../../../../Translation";
import Badge from "../../../../Badge";
import { ArrowDownIcon, ArrowsPointingOutIcon, ChevronDownIcon, EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { webhook } from "../../../../../Resources/Images";
import GeminiPromptPanel from "./GeminiPromptPanel";

export default function GeminiPromptStep({ panelHook, step, refresh, deleteStep, app, userApp, appWebhookStep, setStepToClone }) {
    const { translate } = useTranslation();

    return (
        <div className="flex flex-col border-1 w-max h-min rounded-md p-4 bg-white max-w-80 w-72 min-w-72 border border-gray-300">
            <div className="flex flex-row items-center">
                <img src={app?.icon} alt="webhook" className="w-12 h-12 min-w-12 min-h-12 aspect-square border p-2 bg-gray-50 rounded-md cursor-pointer mr-2 text-black" />
                <div className="flex flex-col justify-center h-full ml-2">
                    <h2 className="text-xl font-bold leading-[1]">{app?.name}</h2>
                    <p className="text-gray-600 font-medium text-wrap text-sm break-all">{step.description}</p>
                </div>

                <div className="flex flex-1 h-full justify-end ml-2">
                    <EllipsisHorizontalIcon onClick={() => panelHook.setOpen(true, <GeminiPromptPanel setStepToClone={setStepToClone} panelHook={panelHook} step={step} refresh={refresh} deleteStep={() => deleteStep(step)} app={app} userApp={userApp} appWebhookStep={appWebhookStep} />)} className="h-8 -mt-2 text-gray-400 cursor-pointer" />
                </div>

            </div>
        </div>
    )
}